import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveLeadershipLanguageMetaSuccess,
  saveLeadershipLanguageMetaFailure,
} from "./action.js";

import { saveLeadershipLanguageMeta } from "./language.js";

// ✅ Saga
function* saveLeadershipLanguageMetaSaga(action) {
  try {

    const { apiPayloadRequest } = action.payload;

    // Validation
    if (
      !apiPayloadRequest?._id ||
      !apiPayloadRequest?.language_code ||
      !apiPayloadRequest?.memberName ||
      !apiPayloadRequest?.memberDesignation
    ) {
      throw new Error("Missing required fields in payload.");
    }

    const response = yield call(saveLeadershipLanguageMeta, apiPayloadRequest);

    if (response?.type === 1) {
      yield put(saveLeadershipLanguageMetaSuccess(response));
      toast.success("Leadership language meta saved successfully!");
      if (action.callback) action.callback({ type: 1, data: response });
    } else {
      throw new Error(response?.error || "Failed to save leadership meta.");
    }
  } catch (error) {
    yield put(saveLeadershipLanguageMetaFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Watcher
export default function* leadershipLanguageMetaWatcherSaga() {
  yield takeLatest(
    actionTypes.SAVE_LEADERSHIP_LANGUAGE_META_REQUEST,
    saveLeadershipLanguageMetaSaga
  );
}
